import { Link } from "react-router-dom";
import { galleryCards } from "@/mocks/gallery";

interface RelatedProjectsProps {
  currentSlug: string;
}

export default function RelatedProjects({ currentSlug }: RelatedProjectsProps) {
  // Pick the next three projects in the gallery order, wrapping around
  const idx = galleryCards.findIndex((p) => p.slug === currentSlug);
  const others: typeof galleryCards = [];
  if (idx !== -1) {
    for (let step = 1; step <= 3; step += 1) {
      others.push(galleryCards[(idx + step) % galleryCards.length]);
    }
  }

  return (
    <section className="relative py-24 md:py-40 px-6 md:px-14 border-t border-white/10">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-16 md:mb-20">
          <h2
            className="font-black uppercase leading-[0.95] tracking-[-0.02em] text-white"
            style={{ fontSize: "clamp(32px, 4.4vw, 64px)" }}
          >
            Other rooms
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {others.map((p) => (
            <Link
              to={`/projects/${p.slug}`}
              key={p.slug}
              className="relative block overflow-hidden rounded-lg bg-black group cursor-pointer no-underline"
              style={{ aspectRatio: "3 / 4" }}
            >
              <img
                src={p.image}
                alt={p.title}
                className="absolute inset-0 w-full h-full object-cover object-center grayscale brightness-[0.55] transition-[transform,filter] duration-[1200ms] ease-out group-hover:scale-[1.06] group-hover:grayscale-0 group-hover:brightness-100"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent transition-opacity duration-[1200ms] ease-out group-hover:opacity-50" />

              <div className="absolute top-5 left-5 text-[10px] uppercase tracking-[0.4em] text-white/70">
                {p.label}
              </div>

              <div className="absolute bottom-5 left-5 right-5">
                <div className="text-[10px] uppercase tracking-[0.4em] text-white/60 mb-2">
                  {p.subtitle}
                </div>
                <h3
                  className="text-white font-black uppercase leading-none tracking-tight"
                  style={{ fontSize: "clamp(22px, 2vw, 32px)" }}
                >
                  {p.title}
                </h3>
                <div className="mt-3 h-px w-8 bg-white/60 transition-all duration-500 group-hover:w-20 group-hover:bg-white" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}